/**
 *
 * Asynchronously loads the component for NoResults
 *
 */

import { lazyLoad } from 'utils/loadable';

export const NoResults = lazyLoad(
  () => import('./index'),
  module => module.NoResults,
);
